import { ChevronDownIcon, Input, Label, SearchIcon } from '@mercai/clever'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { InputSearchProps } from './input-search.type'

export const InputSearch = ({
  onChange,
  value,
  onOpen,
  error,
  title,
  required = false,
}: InputSearchProps) => {
  const { t } = useTranslation('componentSaleOrderSearch')

  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    if (value !== localValue) setLocalValue(value)
  }, [value])

  useEffect(() => {
    const handler = setTimeout(() => {
      if (localValue === value) return
      onChange(localValue)
    }, 500)
    return () => clearTimeout(handler)
  }, [localValue, onChange])

  return (
    <>
      {title || (
        <Label required={required}>{t('searchInputSearchLabel')}</Label>
      )}
      <Input
        aria-label={t('searchInputSearchPlaceholder')}
        placeholder={t('searchInputSearchPlaceholder')}
        iconLeft={<SearchIcon />}
        iconRight={<ChevronDownIcon />}
        value={localValue}
        onChange={setLocalValue}
        onClick={() => onOpen(true)}
        error={error}
      />
    </>
  )
}
